module.exports = __webpack_public_path__ + "static/img/1-2.cb2198a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/1-2.png
// module id = Cug3
// module chunks = 0